export default __webpack_public_path__ + "static/media/moldes.12c13725.jpg";